






























// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import Modal from "@/common/plugins/modal";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "qModal",
})
export default class QModal extends Vue {
  visible = false;
  text = "";
  confirmText = "削除";
  confirmClass = "";
  cancelText = "いいえ";
  cancelClass = "";

  // adding callback function variable
  onConfirm = {};
  onClose = {};
  type = "";
  title = "";
  is_question = true;

  titleMap = {
    // delete
    error: "削除確認",

    // cancel
    info: "変更内容を破棄します。",
  };

  hide() {
    // this method is unchanged
    this.visible = false;
  }
  confirm() {
    // we must check if this.onConfirm is function
    if (typeof this.onConfirm === "function") {
      // run passed function and then close the modal
      this.onConfirm();
      this.hide();
    } else {
      // we only close the modal
      this.hide();
    }
  }
  close() {
    // we must check if this.onConfirm is function
    if (this.onClose && typeof this.onClose === "function") {
      // run passed function and then close the modal
      this.onClose();
      this.hide();
    } else {
      // we only close the modal
      this.hide();
    }
  }
  show(parameters) {
    // making modal visible
    this.visible = true;
    // setting title and text
    this.text = parameters.text;
    this.is_question =
      parameters.is_question === undefined ? true : parameters.is_question;
    this.confirmText = parameters.confirmText ? parameters.confirmText : "削除";
    this.confirmClass = parameters.confirmClass || "mb__add-color-green";
    this.cancelClass = parameters.cancelClass || "mb__add-color-gray";

    this.cancelText = parameters.cancelText ? parameters.cancelText : "いいえ";
    // setting callback function
    this.onConfirm = parameters.onConfirm;
    this.onClose = parameters.onClose;
    this.type = parameters.type;
    this.title = parameters.title
      ? parameters.title
      : this.titleMap[this.type] || "";
  }
  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    Modal.EventBus.$on("show", (parameters) => {
      this.show(parameters);
    });
  }
}
